import BaseService from '../base-service.js';
import { processGeoJsonLayers } from '../utils/geojson-utils.js';

class ModelMappingService extends BaseService {
  constructor() {
    super('model-mappings/');
  }

  async getFeatureLayers() {
    const params = new URLSearchParams({ operation: 'static_geojson' });
    const rawGeoJson = await this.get(`geojson/?${params.toString()}`);

    return processGeoJsonLayers(rawGeoJson);
  }

  async getFeatureData(filename, taz) {
    return this.get('layers/', {
      operation: 'get_feature',
      filename: filename,
      taz: taz,
      t: Date.now() // Cache buster
    });
  }

  async getPendingFeatures(filename) {
    return this.get('layers/', {
      operation: 'get_pending_feature_versions',
      filename: filename
    });
  }

  async updateFeature(updateData) {
    return this.post('layers/', {
      operation: 'update_feature',
      filename: updateData.filename,
      taz: updateData.taz,
      updatedFields: updateData.updatedFields,
      updatedBy: updateData.updatedBy,
      updatedByUserId: updateData.updatedByUserId,
      updatedComment: updateData.updatedComment || ''
    });
  }

  async superviseFeature(supervisionData) {
    if (!supervisionData.versionId) {
      throw new Error('Version ID is required');
    }

    if (!supervisionData.supervisedBy || !supervisionData.supervisedComment) {
      throw new Error('Supervisor name and comment are required');
    }

    return this.post('layers/', {
      operation: 'supervise_feature_version',
      version_id: supervisionData.versionId,
      is_approved: supervisionData.isApproved ? 1 : 0, 
      supervised_by: supervisionData.supervisedBy,
      supervised_by_user_id: supervisionData.supervisedByUserId,
      supervised_comment: supervisionData.supervisedComment,
      feature_header_id: supervisionData.featureHeaderId,
      filename: supervisionData.filename,
      taz: supervisionData.taz
    });
  }
}

export default new ModelMappingService();